module.exports = __webpack_public_path__ + "img/SG.9c0664d5.png";